// src/Auths/CheckAuth.jsx
import { agentMe } from "../lib/api";
import { createContext, useContext, useEffect, useState } from "react";
import Loader from "../components/Loader";

// Create context
const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

const CheckAuth = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      window.location.href = "/login";
      return;
    }

    const fetchUser = async () => {
      try {
        const data = await agentMe();

        // Support either {agent} or {user} or {data}
        const u = data?.agent || data?.user || data?.data || data;
        if (u) {
          setUser(u);
          setLoading(false);
        } else {
          localStorage.removeItem("token");
          window.location.href = "/login";
        }
      } catch (error) {
        console.error(error);
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    };

    fetchUser();
  }, []);

  if (loading) {
    return <Loader/>;
  }

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export default CheckAuth;
